<template>
    <!-- The panel chrome, submission and emit contract are ReadingPanel's; this component exists
         only because the sedation score is an ordinal scale rather than a number, which is the one
         part of a reading panel that isn't shared. -->
    <ReadingPanel panelType="sedation" :patientId="patientId" @readingCompleted="onReadingCompleted">
        <template #input="{ panel, value, setValue, submit, canSubmit }">
            <p style="text-align: left; margin: 0; font-size: 1em; padding-bottom: 8px;">
                {{ panel.inputLabel }}
            </p>

            <div class="sat-scale-container">
                <button
                    v-for="score in satScores"
                    :key="score.value"
                    @click="setValue(score.value)"
                    :class="['sat-button', { 'selected-score': value === score.value, 'positive-score': score.value > 0, 'negative-score': score.value < 0, 'neutral-score': score.value === 0 }]"
                >
                    <div class="score-value">{{ score.value > 0 ? '+' + score.value : score.value }}</div>
                    <div class="score-label">{{ score.label }}</div>
                </button>
            </div>

            <div style="display: flex; justify-content: flex-end; margin-top: 15px;">
                <button class="blue-button" :disabled="!canSubmit" @click="submit()">
                    {{ panel.submitLabel }}
                </button>
            </div>
        </template>
    </ReadingPanel>
</template>

<script>
import ReadingPanel from './ReadingPanel.vue';
import { SAT_SCORES } from './readingPanels';

export default {
    props: {
        patientId: {
            type: String,
            required: true
        }
    },
    components: {
        ReadingPanel
    },
    data() {
        return {
            satScores: SAT_SCORES
        }
    },
    methods: {
        onReadingCompleted(reading) {
            this.$emit('readingCompleted', reading);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";

// Slot content is compiled in this component's scope, not ReadingPanel's, so the styles for the
// scale and its submit button have to live here - ReadingPanel's scoped block cannot reach them.

.sat-scale-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.sat-button {
    display: flex;
    align-items: center;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px 15px;
    cursor: pointer;
    transition: all 0.2s;
    text-align: left;

    &:hover {
        background-color: #e5f1fe;
        border-color: $strongblue;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
}

.score-value {
    font-weight: bold;
    font-size: 1.1em;
    width: 40px;
    text-align: center;
    margin-right: 15px;
}

.score-label {
    flex-grow: 1;
}

.selected-score {
    border-width: 2px;

    &.positive-score {
        background-color: rgba(220, 53, 69, 0.1);
        border-color: $error;
        color: $error;
    }

    &.neutral-score {
        background-color: rgba(0, 173, 80, 0.1);
        border-color: $complete;
        color: $complete;
    }

    &.negative-score {
        background-color: rgba(0, 84, 166, 0.1);
        border-color: $strongblue;
        color: $strongblue;
    }
}

.blue-button {
    background-color: $strongblue !important;
    padding: 5px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    color: white;
    border: none;

    &:disabled {
        background-color: #ccc !important;
        cursor: not-allowed;
    }
}
</style>
